export default function NvidiaChips() {
  const resize = 16;
  const relativeScales = [
    {scale: 1, label: 'H100', flops: ' (7.2 TB/s)', dieSize: 1/resize}, 
    {scale: 200, label: '2027-IC', flops: ' (720 TB/s)', dieSize: 60/resize}
  ];
  const boxSize = 1;

  return (
    <div className="flex flex-col gap-6 mt-8 mb-8 w-full max-w-[690px]">
      {/* Legend */}
      <div className="text-xs font-sans text-center mb-2">
        <span className="inline-flex items-center mr-4">
          <div className="w-3 h-3 bg-gray-700 rounded-[1px] mr-1"></div>
          Scaled to performance
        </span>
        <span className="inline-flex items-center">
          <div className="w-3 h-3 rounded-full bg-[rgba(20,103,20,0.2)] mr-1"></div>
          Scaled to die size
        </span>
      </div>
      
      {/* Main content area with responsive design */}
      <div className="flex flex-row justify-center gap-10 h-full w-full relative pt-5" style={{ minHeight: "200px" }}>
        {relativeScales.map((item, index) => {
          // Calculate grid dimensions to create a square layout
          const gridDimension = Math.floor(Math.sqrt(item.scale / boxSize));
          
          return (
            <div key={item.scale} className="flex-1 flex flex-col">
              {/* Center container - this will contain both the circle and boxes */}
              <div className="flex-1 flex items-center justify-center relative">
                {/* Circle backdrop */}
                <div 
                  className="absolute rounded-full bg-[rgba(20,103,20,0.15)]" 
                  style={{ 
                    width: `${80 * Math.sqrt(item.dieSize)}px`, 
                    height: `${80 * Math.sqrt(item.dieSize)}px`
                  }}
                ></div>
                
                {/* Box rendering */}
                <div className="z-10">
                  {item.scale === 1 ? (
                    <div className="hover:bg-[var(--accent)] transition-bg duration-500 w-[8px] h-[8px] bg-gray-700 rounded-[1px]" />
                  ) : (
                    <div 
                      className="grid gap-[1.5px]"
                      style={{ 
                        gridTemplateColumns: `repeat(${gridDimension}, 8px)`,
                        gridTemplateRows: `repeat(${gridDimension}, 8px)`
                      }}
                    >
                      {Array.from({ length: gridDimension * gridDimension }).map((_, i) => (
                        <div key={i} className="hover:bg-[var(--accent)] transition-bg duration-500 w-[8px] h-[8px] bg-gray-700 rounded-[1px]" />
                      ))}
                    </div>
                  )}
                </div>
              </div>
              
              {/* Label - separate from the flex container */}
              <div className="text-xs font-sans text-center mt-4">
                {item.label} <br />
                {item.flops}
              </div>
            </div>
          );
        })}
      </div>

      <div className="w-full mt-0 relative">
        {/* Horizontal line */}
        <div className="absolute top-0 left-0 w-full h-[1px] bg-gray-400"></div>
        
        {/* Tick marks and year labels with adjusted positioning */}
        <div className="flex flex-row justify-between w-full">
            <div className="flex flex-col items-center ml-[25%]">
              <div className="h-3 w-[1px] bg-gray-400"></div>
              <div className="text-xs font-sans text-center mt-1">2023</div>
            </div>
            
            <div className="flex flex-col items-center mr-[25%]">
              <div className="h-3 w-[1px] bg-gray-400"></div>
              <div className="text-xs font-sans text-center mt-1">2027</div>
            </div>
        </div>
        <div className="text-xs text-right mt-1">*Expected</div>
      </div>
    </div>
  );
}